import React from "react";
import { formatKm } from "../../../utilities/distanceUtils";

interface Props {
  segment: server.dto.FlightSegment
}

const CommercialFlightDetails = (props: Props) => {
  const { segment } = props;
  return (<>
    {segment.frequentFlyerProgram && <tr>
      <td>{RESX.Flight.FrequentFlyer}</td>
      <td>{segment.frequentFlyerProgram.name}</td>
    </tr>}
    <tr>
      <td>{RESX.Flight.By}</td>
      <td>{segment.airline.name}</td>
    </tr>
    {(segment.seats || null) && <tr>
      <td>{RESX.Flight.Seats}</td>
      <td>{segment.seats}</td>
    </tr>}
    {(segment.distance.meter > 0) &&
            <tr>
              <td>{RESX.Flight.Distance}</td>
              <td>{formatKm(segment.distance, 0)}</td>
            </tr>
    }
    {(segment.duration != null) &&
            <tr>
              <td>{RESX.Flight.Duration}</td>
              <td>{segment.duration.formatted}</td>
            </tr>
    }
    {segment.travelClass.value !== "unknown" && <tr>
      <td>{RESX.Flight.TravelClass}</td>
      <td>{segment.travelClass.text}</td>
    </tr>}
    {(segment.aircraft || null) && <tr>
      <td>{RESX.Flight.Aircraft}</td>
      <td>{segment.aircraft}</td>
    </tr>}
    {(segment.eTicket || null) && <tr>
      <td>E-Ticket</td>
      <td>{segment.eTicket}</td>
    </tr>}
  </>
  );
};

export default CommercialFlightDetails;
